import React, {useState} from 'react';
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const AssumedByAgentsContent = ({ data }) => {
    const tableData = (data?.apply?.user_analisys ?? []).flatMap(item => item.details ?? []);

    const [limit, setLimit] = useState(10);
    const passedLimit = tableData.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prev => prev ? null : 10);
    };

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(tableData);

    return (
        <div className="mt-4">
            <span className={"chart-title mb-2"}>SOS assumidos por agentes {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>
            <table id="sosAssumedByAgent" className={"table mt-2 print:break-before-avoid!"}>
                <thead className="thead-background print:table-row-group!">
                    <tr className="text-left">
                        <th onClick={() => handleSort("agent")} className="w-[20%] cursor-pointer">Assumido por {getIcon(order, "agent")}</th>
                        <th onClick={() => handleSort("total_qty")} className="w-[20%] text-center cursor-pointer">SOS assumidos {getIcon(order, "total_qty")}</th>
                        <th onClick={() => handleSort("cpf_qty")} className="w-[20%] text-center cursor-pointer">Total CPF {getIcon(order, "cpf_qty")}</th>
                        <th onClick={() => handleSort("cnpj_qty")} className="w-[20%] text-center cursor-pointer">Total CNPJ {getIcon(order, "cnpj_qty")}</th>
                        <th onClick={() => handleSort("avg_ack_time")} className="w-[20%] text-center cursor-pointer">Tempo médio para assumir {getIcon(order, "avg_ack_time")}</th>
                    </tr>
                </thead>

                <tbody>
                    {(limit ? sortedData.slice(0, limit) : sortedData).map((element, index) => (
                        <tr key={index}>
                            <td className={'w-[20%]'}>{element.agent}</td>
                            <td className={'w-[20%] text-center'}>{element.total_qty}</td>
                            <td className={'w-[20%] text-center'}>{element.cpf_qty}</td>
                            <td className={'w-[20%] text-center'}>{element.cnpj_qty}</td>
                            <td className={'w-[20%] text-center'}>{element.avg_ack_time}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            { passedLimit &&
                <div className="text-end mt-1">
                    <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
                </div>
            }

            <div className="chart-divisor"/>

        </div>
    );
};

export default AssumedByAgentsContent;